import React, { CSSProperties, ReactElement } from 'react';

import { DSTokenMap } from '@rover/kibble/styles';
import MultiSelectPills, {
  Props as MultiSelectPillsProps,
} from '@rover/react-lib/src/components/buttons/MultiSelectPills';

const defaultPillHoverStyle = {
  // borderColor needs to have important if not it won't override the pill and selected pill styles
  borderColor: `${DSTokenMap.INTERACTIVE_BORDER_COLOR_PRIMARY.toString()} !important`,
  backgroundColor: `${DSTokenMap.BACKGROUND_COLOR_TERTIARY.toString()} !important`,
};

const defaultSelectedPillHoverStyle = {
  borderColor: `${DSTokenMap.INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE.toString()} !important`,
  backgroundColor: `${DSTokenMap.BACKGROUND_COLOR_TERTIARY.toString()} !important`,
};

const defaultPillStyle = {
  borderColor: DSTokenMap.INTERACTIVE_BORDER_COLOR_PRIMARY.toString(),
  padding: `${DSTokenMap.SPACE_2X.toString()} ${DSTokenMap.SPACE_3X.toString()}`,
  height: '40px',
  fontSize: DSTokenMap.TEXT_200_FONT_SIZE.toString(),
  fontWeight: 600,
  borderRadius: DSTokenMap.BORDER_RADIUS_PRIMARY.toString(),
  color: DSTokenMap.TEXT_COLOR_SECONDARY.toString(),
};

const defaultSelectedPillStyle = {
  ...defaultPillStyle,
  borderColor: DSTokenMap.INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE.toString(),
  backgroundColor: DSTokenMap.BACKGROUND_COLOR_ACCENT_SECONDARY.toString(),
};

const smallPillStyle = {
  ...defaultPillStyle,
  fontSize: '14px',
  height: '34px',
};

const smallSelectedPillStyle = {
  ...defaultSelectedPillStyle,
  fontSize: '14px',
  height: '34px',
};

type TrainingMultiSelectPillsVariant = 'regular' | 'small';

type DisplayedProperties = {
  displayedPillStyle: CSSProperties;
  displayedSelectedPillStyle: CSSProperties;
};

type TrainingMultiSelectPillsProps = Omit<
  MultiSelectPillsProps,
  'pillStyle' | 'selectedPillStyle' | 'pillHoverStyle' | 'pillSelectedHoverStyle'
> & {
  variant?: TrainingMultiSelectPillsVariant;
};

const getVariantStyles = (variant: TrainingMultiSelectPillsVariant): DisplayedProperties => {
  switch (variant) {
    case 'small':
      return {
        displayedPillStyle: smallPillStyle,
        displayedSelectedPillStyle: smallSelectedPillStyle,
      };
    default:
      return {
        displayedPillStyle: defaultPillStyle,
        displayedSelectedPillStyle: defaultSelectedPillStyle,
      };
  }
};

const TrainingMultiSelectPills = ({
  variant,
  ...rest
}: TrainingMultiSelectPillsProps): ReactElement => {
  const { displayedPillStyle, displayedSelectedPillStyle } = variant
    ? getVariantStyles(variant)
    : {
        displayedPillStyle: defaultPillStyle,
        displayedSelectedPillStyle: defaultSelectedPillStyle,
      };

  return (
    <MultiSelectPills
      {...rest}
      pillStyle={displayedPillStyle}
      selectedPillStyle={displayedSelectedPillStyle}
      pillHoverStyle={defaultPillHoverStyle}
      pillSelectedHoverStyle={defaultSelectedPillHoverStyle}
    />
  );
};

export default TrainingMultiSelectPills;
